/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import { HELP_BUTTON_UI_STORAGE_KEY } from './constants.tsx';

type AccountId = string;

export const updateHelpButtonState = async (
	accountId: AccountId | null,
	data: {
		helpPanelMenu: {
			releaseNotesNotifications: number;
		};
	},
): Promise<void> => {
	if (accountId !== null) {
		try {
			await setUserProperties(accountId, HELP_BUTTON_UI_STORAGE_KEY, JSON.stringify(data));
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			fireErrorAnalytics({
				error: e,
				meta: {
					id: 'updateServerHelpButtonState',
					packageName: 'jiraAtlassianNavigation',
					teamName: 'navigation',
				},
			});
		}
	}
};
